<template>
  <dd-button
    :size="size"
    :color="ColorAssistant.MailboxColor"
    new-icon
    @click="handleClick()"
  ><i class="ddi ddi-conversation" />&nbsp;<span>New Conversation</span></dd-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

export default defineComponent({
  name: 'NewConversationButton',

  props: {
    mailboxId: {
      type: Number,
      required: true,
    },
    mailboxName: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
  },
  data() {
    return { ColorAssistant, RouteAssistant }
  },
  methods: {
    handleClick() {
      RouteAssistant.goToCreateConversation(
        this.$router,
        this.$route.params.accountId,
        this.mailboxId,
        this.mailboxName,
      )
    },
  },
})
</script>
